import Button from "../Button";
import Modal from "./Modal";

type variant =
  | "month_int_limit"
  | "resume_enabled"
  | "video_enabled"
  | "talent_search_enabled"
  | "active_job_limit"
  | "accounts_limit"
  | "ats_enabled";
interface IConstraintModal {
  open: boolean;
  onClose: Function;
  variant: variant;
}

const texts: { [key in variant] } = {
  month_int_limit: {
    text: "You can no longer invite new talent. Please contact sales to renew or upgrade your plan."
  },
  resume_enabled: {
    text: "You can no longer see resumes. Please contact sales to renew or upgrade your plan."
  },
  video_enabled: {
    text: "You can no longer see videos. Please contact sales to renew or upgrade your plan."
  },
  ats_enabled: {
    text: "You can no longer use ATS integration. Please contact sales to renew or upgrade your plan."
  },
  talent_search_enabled: {
    text: "You can no longer search talents. Please contact sales to renew or upgrade your plan."
  },
  active_job_limit: {
    text: "You can no longer create jobs. Please contact sales to renew or upgrade your plan."
  },
  accounts_limit: {
    text: "You can no longer invite members. Please contact sales to renew or upgrade your plan."
  }
};

// The purpose of this modal is to constraint client users from certain operations
const ConstraintModal = ({ variant, open, onClose }: IConstraintModal) => {
  const { text, title } = texts[variant];

  return (
    <Modal open={open} onChange={() => onClose()}>
      <div className="w-[500px] flex flex-col gap-6 pt-6 items-center">
        <p className="font-poppins font-semibold text-2xl ">
          ⚠️ {title || "Your usage limit has expired"}
        </p>
        <p className="text-base text-center font-poppins text-[#8a8a8a] font-medium leading-[32px]">
          {text}
        </p>
        <p className="leading-[36px] text-[18px] font-semibold text-center">
          For support, please email us at{" "}
          <span className="text-odfblue">support@outdefine.com</span> - We're here to help!
        </p>

        <Button onClick={() => onClose()} shapeVariant={2}>
          Ok, Thanks
        </Button>
      </div>
    </Modal>
  );
};

export default ConstraintModal;
